/**
 * @learnzapp/core/subscriptions — pure subscription/entitlement derivation.
 *
 * - ./subscriptionState   the full, canonical derivation (web pin): STATUS,
 *                         deriveStripeState, deriveRevenueCatState,
 *                         deriveStripeOneTimeState, pickBestState,
 *                         getSubscriptionStage, isActiveAt, planFromStripeInterval.
 * - ./subscriptionManager thin helpers (mobile pin): normalizeExpirationDate,
 *                         isSubscriptionActive, isSubscriptionMetadataComplete,
 *                         getPlanFromInterval, getSubscriptionStatus.
 *
 * The two files are complementary (no overlapping export names). SDK plumbing
 * (Firestore/Stripe/RevenueCat fetches) stays in each app; these functions take
 * already-fetched plain objects. Consolidated in Phase 3 with zero behavior change.
 */
export * from './subscriptionState';
export * from './subscriptionManager';
